import { useCallback, useMemo } from "react";

import type { PermissionResource } from "@lib/permissionConstants";
import { PERMISSION_RESOURCE_DISPLAY_NAMES } from "@lib/permissionConstants";

import useI18nNamespace from "@services/useI18nNamespace";

/**
 * Capitalized display strings for permission resources.
 */
export const usePermissionResourceDisplayString = () => {
  const { t: permissionResourceT } = useI18nNamespace("permission-resources");
  const permissionResourceNames = useMemo(() => {
    return PERMISSION_RESOURCE_DISPLAY_NAMES(permissionResourceT);
  }, [permissionResourceT]);

  return useCallback(
    (permissionResource: PermissionResource) => {
      return permissionResourceNames[permissionResource];
    },
    [permissionResourceNames]
  );
};
